import React, {useMemo} from "react";

import {ReactComponent as ArrowDown} from "../../../assets/images/arrow-down.svg";
import {ReactComponent as ArrowUp} from "../../../assets/images/arrow-up.svg";
import {formatTimeSinceShort} from "../../../hooks/formatTimeSince";
import {formatFullNumber} from "../../../hooks/formatNumber";
import {formatDate} from "../../admin/helper/formatters";
import {IVideoListDataItem} from "../../../constants/interfaces";
import Line from "../listWidget/listItem/Line";
import useGetEnvironment from "../../../hooks/useGetEnvironment";

type Props = {
	data: IVideoListDataItem,
	lineSum: number,
	lineWidth: number,
	numberFields: Array<string>,
	showBrand: boolean,
	variant: string
}

const VideoListItem = (props: Props) => {
	const { data, numberFields, lineSum, lineWidth, showBrand, variant } = props;
	const { pubdate, title, trend, brandName, uri } = data;
	const add = trend >= 0;
	const getEnvironment = useGetEnvironment();

	const createUrl = useMemo(()=>{
		let url = "";
		const environment = getEnvironment();
		if (environment === "staging" || environment === "staging2") {
			url = `https://${data.brandId}-${environment}.smartocto.com/#/videos/${data.relationId}/`
		} else {
			url = `https://${data.brandId}.smartocto.com/#/videos/${data.relationId}/`;
		}
		return url
	},[data.brandId, data.relationId, getEnvironment])

	return (
		<div className="list-item">
			<div className="list-item__row list-item__row--social-icons">
				<p className="list-item__timeframe">
					{formatTimeSinceShort(pubdate)}
				</p>
			</div>
			<div className="list-item__row">
				<div className="list-item__header">
					{add ? (
						<ArrowUp className="list-item__arrow" />
					) : (
						<ArrowDown className="list-item__arrow" />
					)}
					<h3 className="list-item__title ">
						{createUrl ? (
							<a href={createUrl} target="_blank" rel="noreferrer">
								{title ? title : uri}
							</a>
						) : (
							title
						)}
					</h3>
				</div>
				<div className={`list-item-stats dynamic-flex-${
					numberFields.length + Number(variant === 'full') + (isNaN(Number(brandName))? 0:1)
					}`}>
						{numberFields.map((field, idx) => {
							if (data[field]) {
								if (field === "pubdate") {
									return <p className="list-item-stat date" key={idx}>{formatDate(data[field])}</p>;
								}
								return <p className="list-item-stat" key={idx}>{formatFullNumber(data[field])}</p>;
							} else {
								return <p className="list-item-stat" key={idx}>n/a</p>
							}
						})}
						{showBrand && brandName && (
							<div className="list-item-stat list-item__extra">
								<div className="list-item__brand">
									<span>{brandName}</span>
								</div>
							</div>
						)}
				</div>
			</div>
			<Line data={data} width={lineWidth} sum={lineSum} />
		</div>
	);
};

export default VideoListItem;
